export enum TriggerTypePopover {
  click = 'click',
  hover = 'hover',
}